import {
  CustomAttributesEntity,
  getCustomAttributesConfig,
} from 'src/graphql/entities/custom-attributes/custom-attributes-config/custom-attributes-config';
import {
  SidePanelSectionKey,
  useCardCustomAttributeKeys,
} from 'src/graphql/entities/side-panel-personalization';

/** One request for the values of a list's unread cards, once one of the section's attributes is on. */
export function useLoadCardCustomAttributeValues({
  sectionKey,
  entity,
  entityIds,
}: {
  sectionKey: SidePanelSectionKey;
  entity: CustomAttributesEntity;
  entityIds: readonly string[];
}): void {
  const enabled = useCardCustomAttributeKeys(sectionKey).length > 0;
  const { useLoadStoredAttributes } = getCustomAttributesConfig(entity);

  useLoadStoredAttributes(enabled ? entityIds : []);
}
